import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import MovieCard from '../movie-card/MovieCard';
import { encryptId } from '../SecurityComponent/cryptoUtils';
import './top10-slant-list.scss';

/**
 * Phim mới nhất — thẻ poster có cạnh trên vát chéo, các thẻ vát so le nhau.
 * (26/09/2026: trước lấy topSingle = top phim lẻ → mục "Phim mới" trang chủ
 *  không hiện phim mới thêm và bỏ sót toàn bộ phim bộ; nay lấy type=new.)
 *
 * Dùng thẳng MovieCard với variant="slant" chứ không tự vẽ poster: MovieCard
 * đã có sẵn thẻ xem nhanh khi rê chuột (mc-popup — ảnh nền, nút Xem ngay,
 * Thích, trailer). Viết lại poster ở đây đồng nghĩa mất toàn bộ phần đó.
 * Phần vát chéo chỉ là CSS gắn theo class của variant.
 */
const Top10SlantList = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiperRef = useRef(null);

    useEffect(() => {
        setLoading(true);
        fetch('/movies-public-api.php?type=new&page=0&size=16')
            .then(r => r.json())
            .then(d => { if (d.success) setItems(d.content || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const updateNav = s => { setIsBeginning(s.isBeginning); setIsEnd(s.isEnd); };

    if (loading) return <div style={{ padding: '20px 0', color: '#555' }}>Loading...</div>;
    if (!items.length) return null;

    return (
        <div className="t10s">
            {!isBeginning && (
                <button className="t10s__nav t10s__nav--prev" aria-label="Trước"
                        onClick={() => swiperRef.current?.slidePrev()}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="t10s__nav t10s__nav--next" aria-label="Sau"
                        onClick={() => swiperRef.current?.slideNext()}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor
                spaceBetween={24}
                slidesPerView="auto"
                onSwiper={s => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
            >
                {items.map((m, idx) => (
                    <SwiperSlide key={m.id} className="t10s__slide">
                        {/* Chiều vát đổi luân phiên. Bám theo chỉ số chứ không dùng
                            :nth-child, vì Swiper có thể chèn thêm slide nhân bản. */}
                        <div className={`t10s__card ${idx % 2 === 0 ? 'is-a' : 'is-b'}`}>
                            <div className="t10s__posterwrap">
                            <MovieCard
                                variant="slant"
                                item={{
                                    id: m.id,
                                    title: m.title,
                                    poster_path: m.posterUrl,
                                    backdrop_path: m.thumbnailUrl || m.posterUrl,
                                    slug: m.slug,
                                    releaseYear: m.releaseYear,
                                    duration: m.duration,
                                    averageRating: m.averageRating,
                                    episodeCount: m.episodeCount,
                                    status: m.status,
                                    genres: m.genres,
                                    description: m.description,
                                    country: m.country,
                                    quality: m.quality,
                                }}
                            />
                                {/* Nam de len poster, khong an theo do dai tieu de,
                                    nho vay day cac the luon bang nhau.
                                    pointer-events:none de khong chan hover cua MovieCard. */}
                                {m.episodeCount > 1 && (
                                    <span className="t10s__eps">
                                        {m.status === 'ongoing' ? `Tập ${m.episodeCount}` : `Trọn bộ ${m.episodeCount} tập`}
                                    </span>
                                )}
                            </div>
                            <Link to={`/watch/${m.slug}/${encryptId(1)}`} className="t10s__meta">
                                <span className="t10s__title">{m.title}</span>
                            </Link>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Top10SlantList;
